export interface Customer {
  id: string;
  customer_Name: string;
  customer_Currency: string;
  customer_Email: string;
  customer_Address: string;
  customer_Phone_Number: string;
  isActive: boolean;
  isDeleted: boolean;
}
export const CustomerInitialData = {
  id: '',
  customer_Name: '',
  customer_Currency: '',
  customer_Email: '',
  customer_Address: '',
  customer_Phone_Number: '',
  isActive: true,
  isDeleted: false,
};
